import { render, staticRenderFns } from "./laws.vue?vue&type=template&id=30b7f82d&scoped=true&"
import script from "./laws.vue?vue&type=script&lang=js&"
export * from "./laws.vue?vue&type=script&lang=js&"
import style0 from "./laws.vue?vue&type=style&index=0&id=30b7f82d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b7f82d",
  null
  
)

export default component.exports